import {
  ArrowLeft,
  InfoCircle,
  Eye,
  EyeSlash,
  ArrowDown2,
  CloseCircle,
} from "iconsax-react";
//import Header from "../../../components/headers/Header"
import { redirect, useLocation, useNavigate } from "react-router-dom";
import { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import instance, { url } from "../../axios/instance";
import { Oval } from "react-loader-spinner";
import { ThemeContext } from "../../context/ThemeContext";
import Color from "color";

export const requestAccountLoader = async ({ request }) => {
  const url = request.url;
  console.log("Request Account Loader - URL:", url);

  // Redirect to VitalRx request page if URL contains vitalrx and request
  if (url.includes("vitalrx") && url.includes("request") && !url.includes("request-vitalrx")) {
    console.log("Redirecting to VitalRx request page from loader");
    const urlObj = new URL(url);
    return redirect("/auth/request-vitalrx" + urlObj.search);
  }

  return null;
};

export default function RequestAccountPage() {
  const navigate = useNavigate();
  const location = useLocation();


  const pharmacyId = location.search.split("?id=")[1];
  const [pharmacy, setPharmacy] = useState(null);
  const [pharmLoading, setPharmLoading] = useState(true);

  const { themeColor } = useContext(ThemeContext);

  async function getPharmacyInfo() {
    instance
      .post("/pharmacy/get_by_id", {
        id: pharmacyId,
      })
      .then((response) => {
        console.log(response.data);
        setPharmacy(response.data);
        setPharmLoading(false);
      })
      .catch((error) => {
        console.log(error.response.data);
        setPharmacy(null);
        setPharmLoading(false);
      });
  }

  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [email, setemail] = useState("");
  const [phone, setphone] = useState("");
  const [clinicName, setclinicName] = useState("");
  const [state, setstate] = useState("");
  const [city, setcity] = useState("");
  const [address, setaddress] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [pharmacies, setPharmacies] = useState([]);
  const [selectedPharmacy, setSelectedPharmacy] = useState(null);
  const [patientpermonth, setpatientpermonth] = useState("");
  const [billPatient, setBillPatient] = useState("");
  const [nationalCompany, setNationalCompany] = useState(false);
  const [type, setType] = useState("distributor");
  const [facilityType, setFacilityType] = useState("clinic");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [otherService, setOtherService] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [requestNotes, setRequestNotes] = useState("");
  const [selectedOther, setSelectedOther] = useState("");

  const facilityTypes = [
    { account_type: "clinic", name: "clinic" },
    { account_type: "clinic", name: "hospital" },
    { account_type: "distributor", name: "distributor" },
    { account_type: "distributor", name: "pharmacy" },
  ];

  const isButtonActive =
    firstname &&
    lastname &&
    email &&
    phone &&
    clinicName &&
    address &&
    facilityType;

  const handleServiceToggle = (service) => {
    setSelectedServices((prev) =>
      prev.includes(service)
        ? prev.filter((s) => s !== service)
        : [...prev, service]
    );
  };

  async function createRequest() {
    setLoading(true);
    instance
      .post("/doctor/facility/new", {
        contactName: `${firstname} ${lastname}`,
        email: email,
        homePhone: phone,
        address: address,
        name: clinicName,
        pharmacy_id: pharmacy.id,
        type: facilityTypes
          .find(
            (type) => type.name.toLowerCase() === facilityType.toLowerCase()
          )
          .account_type.toLowerCase(),
        facilityType: facilityType.toLowerCase(),
        services: otherService
          ? [
            ...selectedServices.filter((service) => service !== "Other"),
            otherService,
          ]
          : selectedServices,
        notes: requestNotes,
      })
      .then((response) => {
        console.log(response.data);
        setLoading(false);
        navigate("/auth/request-success");
      })
      .catch((error) => {
        setLoading(false);
        setErrorMessage(error.response.data.message);
        console.log(error.response.data);
      });
  }

  // logo effect
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    const clinicLogo = window.localStorage.getItem("CLINIC_LOGO");

    if (clinicLogo === "null" || !clinicLogo) {
      setLogo("/clinic/images/logo1.png");
    } else {
      setLogo(clinicLogo);
    }

    getPharmacyInfo();
  }, []);

  useEffect(() => {
    if (selectedServices.includes("Other")) {
      setSelectedOther(true);
    } else {
      setSelectedOther(false);
    }
  }, [selectedServices]);

  const services = [
    "Sterile compounding",
    "Non-sterile compounding",
    "Medication dispensing",
    "Medical supplies",
    "Other",
  ];

  if (pharmLoading) {
    return (
      <div className="h-[100svh] flex justify-center items-center">
        <Oval
          color={themeColor}
          secondaryColor={Color(themeColor).alpha(0.2)}
          strokeWidth={4}
          width={24}
          height={24}
        />
      </div>
    );
  }

  if (!location.search || !pharmacyId || !pharmacy) {
    return <div>Invalid pharmacy URL, contact phramacy</div>;
  }

  return (
    <div>
      <header className="px-4 sm:px-10 py-4 sticky left-0 right-0 top-0 bg-white">
        <img
          src={
            !pharmacy.logo_path
              ? "/images/logo1.png"
              : `${url}${pharmacy?.logo_path}`
          }
          className="w-36"
        />
      </header>

      <div className="flex flex-col items-center py-8">
        <div className="px-4 w-full sm:w-[560px] flex flex-col gap-8">
          <div>
            {/* <div
              onClick={() => navigate(-1)}
              className="flex gap-1 items-center text-[14px] font-medium cursor-pointer mb-2"
            >
              <ArrowLeft size={20} /> Back
            </div> */}
            <div className="text-[20px] sm:text-[22px] font-bold">
              Request a new account
            </div>
            <div className="font-regular text-[14px] text-gray-500">
              Fill in your credentials to request an account from pharmacy.
            </div>
          </div>

          <div className="space-y-4">
            {/* <div className="relative">
              <div className="font-medium text-[14px] mb-2">
                Search pharmacy
              </div>

              {!selectedPharmacy ? (
                <input
                  onChange={(e) => searchPharmacy(e)}
                  className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                  placeholder="Enter pharmacy name"
                />
              ) : (
                <div className="w-full p-2 border flex justify-between items-center rounded-[4px] text-[14px]">
                  {selectedPharmacy.pharmacy_name}
                  <button onClick={() => setSelectedPharmacy(null)}>
                    <CloseCircle variant="Bold" size={16} color="#3a1b44" />
                  </button>
                </div>
              )}

              {pharmacies.length < 1 ? null : (
                <div className="w-full bg-white border shadow-md mt-2 rounded-[4px]">
                  {pharmacies.map((pharmacy) => (
                    <div
                      onClick={() => {
                        setSelectedPharmacy(pharmacy);
                        setPharmacies([]);
                      }}
                      className="font-regular text-[14px] hover:bg-gray-100 p-2 cursor-pointer my-1"
                    >
                      {pharmacy.pharmacy_name}
                    </div>
                  ))}
                </div>
              )}
            </div> */}

            <div>
              <div className="font-medium text-[14px] mb-2">Pharmacy name</div>
              <div className="border col-span-1 border-gray-300 bg-gray-100 cursor-not-allowed outline-none rounded-[4px] text-[14px] font-regular p-2 text-gray-500">
                {pharmacy.pharmacy_name}
              </div>
            </div>

            <div>
              <div className="font-medium text-[14px] mb-2">
                Contact name <span className="text-red-500">*</span>
              </div>
              <div className="grid grid-cols-2 gap-3 w-full">
                <input
                  onChange={(e) => setfirstname(e.target.value)}
                  className="border col-span-1 border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                  placeholder="Firstname"
                />
                <input
                  onChange={(e) => setlastname(e.target.value)}
                  className="border col-span-1 border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                  placeholder="Lastname"
                />
              </div>
            </div>

            <div>
              <div className="font-medium text-[14px] mb-2">
                Facility type <span className="text-red-500">*</span>
              </div>
              <select
                onChange={(e) => setFacilityType(e.target.value)}
                className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2 capitalize"
                placeholder="name@email.com"
                value={facilityType}
              >
                {facilityTypes.map((type, index) => (
                  <option value={type.name} key={index}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <div className="font-medium text-[14px] mb-2">
                Email address <span className="text-red-500">*</span>
              </div>
              <input
                onChange={(e) => setemail(e.target.value)}
                className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                placeholder="name@email.com"
              />
            </div>

            <div>
              <div className="font-medium text-[14px] mb-2">
                Contact phone <span className="text-red-500">*</span>
              </div>
              <input
                onChange={(e) => setphone(e.target.value)}
                className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                placeholder="+1 (234) 5690"
              />
            </div>

            <div>
              <div className="font-medium text-[14px] mb-2">
                Business name <span className="text-red-500">*</span>
              </div>
              <input
                onChange={(e) => setclinicName(e.target.value)}
                className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                placeholder="Blendcarerx"
              />
            </div>
            <div>
              <div className="font-medium text-[14px] mb-2">
                Full Address <span className="text-red-500">*</span>
              </div>
              <input
                onChange={(e) => setaddress(e.target.value)}
                className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                placeholder="Enter your full address"
              />
            </div>
            <div>
              <div className="font-medium text-[14px] mb-2">
                Pharmacy services requested{" "}
                <span className="text-red-500">*</span>
              </div>
              {services.map((service, index) => (
                <label key={index} className="flex items-center my-2">
                  <input
                    type="checkbox"
                    checked={selectedServices.includes(service)}
                    onChange={() => handleServiceToggle(service)}
                    className="h-4 w-4 text-primary focus:ring-blue-500 border-gray-300 rounded"
                  />
                  <span className="ml-2 text-gray-700 text-sm">{service}</span>
                </label>
              ))}
              <div className="text-xs text-gray-500">Select all that apply</div>
            </div>
            {selectedOther && (
              <div>
                <div className="font-medium text-[14px] mb-2">
                  Please specify the services you are requesting
                </div>
                <input
                  onChange={(e) => setOtherService(e.target.value)}
                  className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                  placeholder="Please specify"
                  value={otherService}
                />
              </div>
            )}
            <div>
              <div className="font-medium text-[14px] mb-2">
                Additional notes or Special requests
              </div>
              <textarea
                onChange={(e) => setRequestNotes(e.target.value)}
                className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2 resize-none"
                rows={4}
                maxLength={500}
                value={requestNotes}
              />
            </div>
            {/* <div>
              <div className="font-medium text-[14px] mb-2">
                Patient per month
              </div>
              <input
                onChange={(e) => setpatientpermonth(e.target.value)}
                type="number"
                className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                placeholder="Patient per month"
              />
            </div> */}

            {/* <div>
              <div className="font-medium text-[14px] mb-2">
                Billing preference (Specify if we should bill your patient)
              </div>
              <select
                onChange={(e) => setBillPatient(e.target.value)}
                className="border w-full border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
              >
                <option value="">--Select--</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div> */}

            {/* <div>
              <div className="font-medium text-[14px] mb-2">Address</div>
              <div className="grid grid-cols-2 gap-3 w-full">
                <input
                  onChange={(e) => setstate(e.target.value)}
                  className="border col-span-1 border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                  placeholder="State"
                />
                <input
                  onChange={(e) => setcity(e.target.value)}
                  className="border col-span-1 border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                  placeholder="City"
                />
              </div>
            </div> */}

            {/* <div>
              <div className="grid grid-cols-2 gap-3 w-full">
                <input
                  onChange={(e) => setaddress(e.target.value)}
                  className="border col-span-1 border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                  placeholder="Address"
                /> */}

            {/* <input
                  onChange={(e) => setzipcode(e.target.value)}
                  className="border col-span-1 border-gray-300 outline-none rounded-[4px] text-[14px] font-regular p-2"
                  placeholder="Zipcode"
                /> */}
            {/* </div>
            </div> */}

            {/* <div className="flex gap-2 items-center">
              <input
                type="checkbox"
                checked={nationalCompany}
                onChange={() => setNationalCompany(!nationalCompany)}
                className="accent-primary"
              />

              <div className="text-[14px]">
                Are you a National or Regional Telehealth-Only Company?
              </div>
            </div> */}

            <div>
              {/* <div className="py-3 font-regular text-[13px]">By siging up you agree to BlendcareRx's <span className="text-primary">Terms of Uses</span>, <span className="text-primary">Privacy Policy</span>, <span className="text-primary">HIPAA Policy, Delivery Policy</span>, and <span className="text-primary">HIPAA marketing authorization</span></div> */}
              {errorMessage && (
                <span className="text-sm block mb-2 text-[tomato]">
                  {errorMessage}
                </span>
              )}
              <button
                disabled={!isButtonActive}
                style={{
                  backgroundColor: !isButtonActive
                    ? Color(pharmacy.theme_color).alpha(0.2)
                    : pharmacy.theme_color,
                  color: !isButtonActive ? pharmacy.theme_color : "#fff",
                }}
                onClick={createRequest}
                className={`w-full ${!isButtonActive ? "cursor-not-allowed" : ""
                  }  p-3 font-medium text-[14px] rounded-[4px]`}
              >
                {!loading ? "Request account" : "Requesting..."}
              </button>
            </div>

            <div>
              <div
                style={{ color: pharmacy.theme_color }}
                className="font-bold text-[15px] mb-1"
              >
                New Clinic Account Request
              </div>

              <div className="font-regular text-[14px] text-gray-500">
                Sign your Medical Clinic up to become a {pharmacy.pharmacy_name} Pharmacy
                provider and begin filling your patient's prescriptions by mail
                or pickup at one of our convenient pharmacy locations. After
                being accepted by a member of our team, we will set you up with
                a login to BlendCareRx Careapps, where you can submit
                prescriptions directly to us, on behalf of your patients.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
